import React, { useEffect, useState } from "react";
import { Dropdown, Spinner } from "react-bootstrap";
import { Form } from "react-bootstrap";
import { InputLimit } from "../../constants";
import "./styles.scss";

export default function SimpleDropdown({ value, label, options, optionsLoading, handleSelect, disabled, showSearch, onSearch }) {
  const [search, setSearch] = useState("");
  const [dropdownLabel, setDropdownLabel] = useState("");
  const [filteredOptions, setFilteredOptions] = useState([]);

  useEffect(() => {
    onSearch && onSearch(search);
  }, [search, onSearch]);

  useEffect(() => {
    if (showSearch && search) {
      const filtered = options.filter((option) => option.label.toLowerCase().includes(search.toLowerCase()));
      setFilteredOptions(filtered);
    } else {
      setFilteredOptions(options);
    }
  }, [options, search, showSearch]);

  useEffect(() => {
    if (typeof value === "string" && value) {
      const filtered = options.find((option) => option.value === value);
      if (filtered) {
        setDropdownLabel(filtered.label);
      } else {
        setDropdownLabel(label);
      }
    } else if (typeof value === "object" && value.label) {
      setDropdownLabel(value.label);
    } else {
      setDropdownLabel(label);
    }
  }, [value, label, options]);

  return (
    <Dropdown style={{ width: "100%" }} className="mt-0 simple-dropdown-container">
      <Dropdown.Toggle
        disabled={disabled || false}
        className="bg-white"
        style={{ width: "100%", border: "1px solid #E4E6EF", textAlign: "left", padding: "0.65rem 1.1rem", background: "white !important" }}
        variant="transparent"
      >
        {dropdownLabel}
      </Dropdown.Toggle>
      <Dropdown.Menu style={{ minWidth: "100%" }}>
        {optionsLoading ? (
          <div className="w-100 d-flex justify-content-center align-items-center" style={{ minHeight: "25vh" }}>
            <Spinner animation="border" variant="primary" />
          </div>
        ) : (
          <div style={{ maxHeight: "25vh", position: "relative", overflowY: "auto" }} onClick={(e) => e.stopPropagation()}>
            {showSearch && (
              <div className="mx-4">
                <Form.Control
                  max={InputLimit.TEXT}
                  type="text"
                  placeholder={"Search..."}
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                  }}
                />
              </div>
            )}
            {showSearch && <Dropdown.Divider />}
            {filteredOptions.map((option, optionIndex) => {
              return (
                <Dropdown.Item
                  key={optionIndex}
                  className="dropdown-hover"
                  onSelect={(e) => {
                    handleSelect(option, optionIndex);
                    setSearch("");
                  }}
                >
                  {option.label}
                </Dropdown.Item>
              );
            })}
          </div>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
}

export function PrimarySimpleDropdown({ value, label, options, handleSelect, disabled }) {
  return (
    <Dropdown className="mt-0">
      <Dropdown.Toggle variant="primary" className="btn-sm text-white white-toogle-arrow" disabled={disabled || false} style={{ border: "1px solid #E4E6EF", textAlign: "left", padding: "0.65rem 1.1rem" }}>
        {value.label ? value.label : label}
      </Dropdown.Toggle>
      <Dropdown.Menu style={{ minWidth: "100%" }}>
        <div style={{ maxHeight: "25vh", position: "relative", overflowY: "auto" }} onClick={(e) => e.stopPropagation()}>
          {options.map((option, optionIndex) => {
            return (
              <Dropdown.Item
                key={optionIndex}
                className="dropdown-hover"
                onSelect={(e) => {
                  handleSelect(option, optionIndex);
                }}
              >
                {option.label}
              </Dropdown.Item>
            );
          })}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
}
